import { FiPhone, FiMessageSquare, FiMapPin, FiInstagram, FiFacebook } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import logo from './assets/images.jpg';

const Footer = () => {
  const navigate = useNavigate();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleNavigation = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  return (
    <footer className="bg-gray-900 text-gray-300 py-16 px-4">
      <div className="container mx-auto">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div>
            <div className="flex items-center mb-6">
              <img
                src={logo}
                alt="Donzi Art Academy"
                className="h-10 w-auto mr-3 cursor-pointer"
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              />
              <span className="text-xl font-light tracking-wide" style={{ color: '#052e5a' }}>
                DONZI ART ACADEMY
              </span>
            </div>
            <p className="text-gray-400 mb-6 font-light tracking-wide text-sm">
              Where creativity meets discipline. Nurturing Egypt's next generation of artists since 2011.
            </p>
            <div className="flex space-x-4">
              <div
                className="text-gray-400 hover:text-white transition cursor-pointer"
                onClick={() => window.open('https://www.instagram.com/donzi_art.academy/', '_blank')}
              >
                <FiInstagram className="w-5 h-5" />
              </div>
              <div
                className="text-gray-400 hover:text-white transition cursor-pointer"
                onClick={() => window.open('https://www.facebook.com/donziartacademy/', '_blank')}
              >
                <FiFacebook className="w-5 h-5" />
              </div>
            </div>
          </div>

          <div>
            <h4 className="font-light tracking-wide text-white text-lg mb-6 uppercase">Quick Links</h4>
            <ul className="space-y-3 text-sm font-light tracking-wide">
              <li><div className="text-gray-400 hover:text-white transition cursor-pointer" onClick={() => handleNavigation('/about')}>About Us</div></li>
              <li><div className="text-gray-400 hover:text-white transition cursor-pointer" onClick={() => handleNavigation('/donzi')}>Donzi El Housseiny</div></li>
              <li><div className="text-gray-400 hover:text-white transition cursor-pointer" onClick={() => handleNavigation('/exhibitions')}>Exhibitions</div></li>
              <li><div className="text-gray-400 hover:text-white transition cursor-pointer" onClick={() => handleNavigation('/annual-exhibitions')}>Activities and Workshops</div></li>
              <li><div className="text-gray-400 hover:text-white transition cursor-pointer" onClick={() => handleNavigation('/register')}>Register</div></li>
            </ul>
          </div>

          <div>
            <h4 className="font-light tracking-wide text-white text-lg mb-6 uppercase">Locations</h4>
            <ul className="space-y-3 text-sm font-light tracking-wide">
              <li className="flex items-start gap-3">
                <FiMapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <div>
                  <div className="text-white">New Cairo Branch</div>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <FiMapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <div>
                  <div className="text-white">6th October Branch</div>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <FiMapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <div>
                  <div className="text-white">UpTown Branch</div>
                </div>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-light tracking-wide text-white text-lg mb-6 uppercase">Contact Us</h4>
            <div className="space-y-4 text-sm font-light tracking-wide">
              <div className="flex items-center text-gray-400 hover:text-white transition cursor-pointer" onClick={() => window.location.href = 'tel:01021676660'}>
                <FiPhone className="mr-3 w-4 h-4 flex-shrink-0" /> 01021676660
              </div>
              <div className="flex items-center text-gray-400 hover:text-white transition cursor-pointer" onClick={() => window.open('https://wa.me/201021676660', '_blank')}>
                <FiMessageSquare className="mr-3 w-4 h-4 flex-shrink-0" /> WhatsApp
              </div>
              <div className="flex items-start gap-3">
                <svg className="w-4 h-4 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <div className="text-gray-400 hover:text-white transition cursor-pointer" onClick={() => window.location.href = 'mailto:donzi.academy@gmail.com'}>
                  donzi.academy@gmail.com
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center text-sm font-light tracking-wide text-gray-500">
          <div>© {new Date().getFullYear()} Donzi Art Academy. All rights reserved.</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;